"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var SignupContext_1 = require("../SignupContext");
var DiscountPercentage_1 = require("../components/DiscountPercentage");
var signup_modal_1 = require("../utils/signup-modal");
var ga_1 = require("../../../utils/ga");
var hooks_1 = require("preact/hooks");
var SignUpStep2 = function (_a) {
    var discountPercent = _a.discountPercent, upTo = _a.upTo, email = _a.email, handleEmailChange = _a.handleEmailChange;
    var _b = (0, hooks_1.useContext)(SignupContext_1.SignupContext), formStep = _b.formStep, setFormStep = _b.setFormStep, setModalOpen = _b.setModalOpen;
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("p", { class: "signup-modal__eyebrow signup-modal__eyebrow--step-1" },
            "Congratulations!",
            (0, preact_1.h)("span", { class: "signup-modal__eyebrow--regular" }, " You won ")),
        (0, preact_1.h)(DiscountPercentage_1.default, { upTo: upTo, discountPercent: discountPercent }),
        (0, preact_1.h)("p", { class: "signup-modal__policies signup-modal__policies--step-1" },
            "By submitting your email address, you consent to receiving our emails, and to our",
            ' ',
            (0, preact_1.h)("a", { href: "/policies/terms-of-service" }, "Terms of Service"),
            " and",
            ' ',
            (0, preact_1.h)("a", { href: "/policies/privacy-policy" }, "Privacy Policy"),
            ". You can unsubscribe from our emails at any time."),
        (0, preact_1.h)("form", { class: "signup-modal__form", onSubmit: function (event) {
                event.preventDefault();
                (0, signup_modal_1.createClientSubscription)(email, 'XbizeQ', location.pathname, 'intro15');
                (0, ga_1.sendEvent)('ce_sign_up_email');
                setFormStep(2);
            } },
            (0, preact_1.h)("input", { class: "signup-modal__input", onInput: function (event) { return handleEmailChange(event); }, placeholder: "Email Address", type: "email", value: email, required: true }),
            (0, preact_1.h)("button", { class: "signup-modal__button signup-modal__button--email", type: "submit" }, "AGREE & SUBMIT")),
        (0, preact_1.h)("div", { class: "signup-modal__step" },
            "Step ",
            formStep,
            " of 2"),
        (0, preact_1.h)("button", { class: "signup-modal__cancel signup-modal__cancel--first", onClick: function () {
                setModalOpen(false);
            } }, "No Thanks")));
};
exports.default = SignUpStep2;
